var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 647 158 145",
    enableBackground: "new 0 647 158 145",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.7,695.1l35.3,20.3c6.1,3.4,6.1,12.2,0,15.6l-35.3,20.5c-6.1,3.4-13.5-0.9-13.5-7.7v-40.8 C54.3,696.1,61.6,691.8,67.7,695.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ED2A26",
    d: "M158,668.5c0,6.4-5.2,11.6-11.6,11.6c-6.4,0-11.6-5.2-11.6-11.6c0-6.4,5.2-11.6,11.6-11.6 C152.9,656.9,158,662.1,158,668.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED2A26",
    d: "M130.2,652.9c-0.1,3.2-2.8,5.7-5.9,5.6s-5.7-2.8-5.5-5.9c0.1-3.2,2.8-5.7,5.9-5.6 C127.8,647.1,130.3,649.7,130.2,652.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED2A26",
    d: "M13.4,773.5c-0.2,3.7-3.3,6.6-7,6.4s-6.6-3.3-6.4-7c0.2-3.7,3.3-6.6,7-6.4S13.5,769.8,13.4,773.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DA1F27",
    d: "M105.7,707.3c0,0.3,0,0.4,0,0.7c16.4,9,29,24.6,33.7,43.5c4.7-10.3,6.9-22,5.8-34.1 c-3.2-37-35.2-64.6-72-62.7C91.2,665.8,103.9,684.8,105.7,707.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED2A26",
    d: "M8.5,729.2c0.3,3.7,0.9,7.3,1.8,10.8c9.9-21.9,31-37.9,56.7-40.1c14-1.2,27.3,1.9,38.8,8.2 c0-0.3,0-0.4,0-0.7c-2-22.5-14.5-41.6-32.4-52.6c-0.8,0-1.5,0.1-2.3,0.2C33.3,658.2,5.3,691.4,8.5,729.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF1F24",
    d: "M105.8,708c2.8,37.5-25,70.4-62.6,73.6c-0.8,0.1-1.5,0.1-2.3,0.2c12.1,7.5,26.6,11.3,41.9,10 c25.6-2.2,46.8-18.2,56.7-40.1C134.7,732.6,122.3,717,105.8,708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C72127",
    d: "M105.8,708c-11.4-6.3-24.8-9.4-38.8-8.2c-25.6,2.2-46.8,18.2-56.7,40.1c4.5,17.8,15.6,32.6,30.6,41.8 c0.8,0,1.5-0.1,2.3-0.2C80.8,778.4,108.7,745.5,105.8,708z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M66.3,692.3l40.1,23.1c6.9,3.9,6.9,13.8,0,17.6l-40.1,23.3c-6.9,3.9-15.3-1-15.3-8.9v-46.4 C51,693.4,59.4,688.5,66.3,692.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main_logo.aee6d99d19ac254709885d0a0a191305.svg";
export { ForwardRef as ReactComponent };